import { useConfigStore } from '@/stores';
import { useCallback, useRef } from 'react';

export function useTTS() {
    const synth = useRef(window.speechSynthesis);
    const language = useConfigStore((state) => state?.config?.ui?.language);
    const voice = useConfigStore((state) => state?.config?.tts?.voice);
    const timeoutRef = useRef<number | null>(null);

    const speak = useCallback((text: string, lang: string = 'en-US', delay: number = 200) => {
        if (!synth.current || !voice) return;

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        synth.current.cancel();

        timeoutRef.current = window.setTimeout(() => {
            const utterance = new SpeechSynthesisUtterance(text);
            utterance.lang = language || lang;
            synth.current?.speak(utterance);
        }, delay);
    }, [language, voice]);

    const cancel = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        synth.current?.cancel();
    };

    return { speak, cancel };
}
